interface RenewalTimelineProps {
  expiryLabel: string;
}

// Shows that paying today doesn't cut the current period: the new one starts at expiry.
export function RenewalTimeline({ expiryLabel }: RenewalTimelineProps) {
  return (
    <div
      role="img"
      aria-label={`Pay today and your new period still starts on ${expiryLabel}`}
      className="space-y-2"
    >
      <div className="flex items-center">
        <span className="h-4 w-4 shrink-0 rounded-full border-[3px] border-primary bg-card" />
        <span className="h-1.5 flex-1 rounded-full bg-primary" />
        <span className="h-4 w-4 shrink-0 rounded-full bg-primary" />
        <span className="h-1.5 flex-1 rounded-full bg-secondary" />
        <span className="h-4 w-4 shrink-0 rounded-full border-[3px] border-secondary bg-card" />
      </div>
      <div className="grid grid-cols-3 text-xs">
        <div>
          <p className="text-muted-foreground">Pay today</p>
          <p className="font-semibold text-foreground">You keep every day</p>
        </div>
        <div className="text-center">
          <p className="text-muted-foreground">Subscription ends</p>
          <p className="font-semibold text-foreground">{expiryLabel}</p>
        </div>
        <div className="text-right">
          <p className="text-muted-foreground">New period</p>
          <p className="font-semibold text-foreground">Starts {expiryLabel}</p>
        </div>
      </div>
    </div>
  );
}
